export enum PlatformEnum {
  desktop = 'desktop',
  mobile = 'mobile',
}
